/**
 * Mouse-follow 3D tilt for the "What You Can Identify" grid.
 * Sets --mouse-x and --mouse-y (0–1) on the stage for CSS to use.
 */
export class IdentifySection3D {
  private stage: HTMLElement | null = null;
  private boundUpdate: (e: MouseEvent) => void;
  private rafId: number | null = null;
  private targetX = 0.5;
  private targetY = 0.5;

  constructor() {
    this.boundUpdate = this.update.bind(this);
  }

  init(): void {
    this.stage = document.getElementById('identify-3d-stage');
    if (!this.stage) return;

    this.stage.addEventListener('mouseenter', () => {
      this.stage?.addEventListener('mousemove', this.boundUpdate);
    });
    this.stage.addEventListener('mouseleave', () => {
      this.stage?.removeEventListener('mousemove', this.boundUpdate);
      this.targetX = 0.5;
      this.targetY = 0.5;
      this.scheduleUpdate();
    });
    this.scheduleUpdate();
  }

  private update(e: MouseEvent): void {
    if (!this.stage) return;
    const rect = this.stage.getBoundingClientRect();
    this.targetX = (e.clientX - rect.left) / rect.width;
    this.targetY = (e.clientY - rect.top) / rect.height;
    this.scheduleUpdate();
  }

  private scheduleUpdate(): void {
    if (this.rafId !== null) return;
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      if (this.stage) {
        this.stage.style.setProperty('--mouse-x', this.targetX.toFixed(4));
        this.stage.style.setProperty('--mouse-y', this.targetY.toFixed(4));
      }
    });
  }

  dispose(): void {
    this.stage?.removeEventListener('mousemove', this.boundUpdate);
    if (this.rafId !== null) cancelAnimationFrame(this.rafId);
    this.stage = null;
  }
}
